import { setGoods } from '../../actions';
import { identityPayload, createReducer, forAction } from '../../utils';

const initialState = [];

export default createReducer(
  [forAction(setGoods, identityPayload)],
  initialState,
);
